var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('OrganizationProfileForm',{attrs:{"loading":_vm.createStore.isLoading,"values":_vm.createStore.data,"errors":_vm.createStore.formErrors,"admin":true,"submitText":"Create"},on:{"submit":_vm.createOrganization}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }